/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import TrackCardContainer from '../../containers/TracksPage/TrackCardContainer';
import LessonCardContainer from '../../components/LessonCard/LessonCardContainer';
// @ts-expect-error Could not find a declaration file for module
import WizardNoResultsError from '../../components/Errors/WizardNoResultsError';
import ResponsiveCardGridContainer from '../../components/ResponsiveCardGridContainer';
import styled from 'styled-components';
import { device } from '../../constants/StyledComponentConstants';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import UIButton from 'UIComponents/button/UIButton';
import UsageTracker from '../../utils/UsageTracker';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment, useEffect, useMemo } from 'react';
import { UserAttributeKeys, useUserAttribute } from '../../features/userAttributes';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import Raven from 'raven-js';
import { useHistory } from 'react-router-dom';
import { ShortCard } from '../../features/cards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorContainer = styled.div.withConfig({
  displayName: "WizardResults__ErrorContainer",
  componentId: "sc-1oxlwqz-0"
})(["text-align:center;padding-top:0;&.padded{padding-top:40px;}"]);
const ResultsMessage = styled(FormattedMessage).withConfig({
  displayName: "WizardResults__ResultsMessage",
  componentId: "sc-1oxlwqz-1"
})(["font-size:16px;"]);
const useWizardLoginRedirect = () => {
  const history = useHistory();
  const [[loginRedirectUrl]] = useSearchParam('loginRedirectUrl');
  return useMemo(() => {
    if (!loginRedirectUrl || !loginRedirectUrl.length) return false;
    try {
      const {
        pathname,
        search
      } = new URL(loginRedirectUrl);
      // redirects to login redirect url after updating learning interest
      // removes the base path from the absolute url (if existing) for a better experience
      const newPath = pathname.replace(/academy\/([0-9]+\/)?/, '');
      history.replace({
        pathname: newPath,
        search
      });
      return true;
    } catch (_unused) {
      Raven.captureMessage(`Wizard: error redirecting to loginRedirectUrl`, {
        extra: {
          loginRedirectUrl
        }
      });
    }
    return false;
  }, [history, loginRedirectUrl]);
};
const WizardResults = ({
  catalogUrl,
  isRequesting,
  onOpenResultsClick,
  results,
  totalResultCount
}) => {
  const isRedirecting = useWizardLoginRedirect();
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const noResultsExist = () => !results.length;
  const {
    setUserAttribute
  } = useUserAttribute(UserAttributeKeys.WIZARD_COMPLETION_DATE);
  const trackCourseClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-result-card',
      contentType: 'course'
    });
  };
  const trackLessonClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-result-card',
      contentType: 'lesson'
    });
  };
  const trackShortClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-result-card',
      contentType: 'short'
    });
  };
  const getCards = () => {
    return results && results.length > 0 ? results.map((result, index) => {
      if (!result) return null;
      const {
        id,
        contentType,
        language
      } = result;
      return contentType === 'SHORT_FORM_CONTENT' ? /*#__PURE__*/_jsx(ShortCard, {
        appearsIn: "wizard-results",
        language: language,
        onClick: trackShortClick,
        position: index + 1,
        shortId: id
      }, `short-${id}`) : contentType === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
        appearsIn: "wizard-results",
        onClick: trackCourseClick,
        position: index + 1,
        trackId: id
      }, `track-${id}`) : /*#__PURE__*/_jsx(LessonCardContainer, {
        appearsIn: "wizard-results",
        lessonId: id,
        onClick: trackLessonClick,
        position: index + 1
      }, `lesson-${id}`);
    }) : null;
  };
  const trackCatalogLinkClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-view-results-on-catalog',
      location: 'results page link'
    });
  };
  const renderResultsLink = () => {
    return /*#__PURE__*/_jsx(UIRouterLink, {
      className: isMobile ? 'display-block text-center' : '',
      onClick: trackCatalogLinkClick,
      to: catalogUrl,
      children: /*#__PURE__*/_jsx(ResultsMessage, {
        message: "learningCenter.wizard.modal.stepfinal.resultslink",
        options: {
          resultsCount: totalResultCount
        }
      })
    });
  };
  const renderError = () => {
    return /*#__PURE__*/_jsxs(ErrorContainer, {
      className: isMobile ? '' : 'padded',
      children: [/*#__PURE__*/_jsx(WizardNoResultsError, {}), isMobile && /*#__PURE__*/_jsx(UIButton, {
        onClick: onOpenResultsClick,
        style: {
          width: 'auto'
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.modal.step4.openresults"
        })
      })]
    });
  };
  const renderLoadingState = () => {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      size: "medium",
      style: {
        position: 'absolute',
        top: '200px',
        left: '50%'
      }
    });
  };
  useEffect(() => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-view-results'
    });
  }, []);
  useEffect(() => {
    setUserAttribute(Date.now());
  }, [setUserAttribute]);
  return isRequesting || isRedirecting ? renderLoadingState() : noResultsExist() ? renderError() : /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ResponsiveCardGridContainer, {
      className: 'noBorder',
      columnSize: 200,
      columns: 3,
      maxCardWidth: 314,
      nowrap: true,
      children: getCards()
    }), totalResultCount > results.length && renderResultsLink()]
  });
};
export default WizardResults;